export default __webpack_public_path__ + "locales/az/InviteDialog.json?hash=f2fa852b50c3c3fe17c698ec0f53cc88";